import { AuthenticationService } from './services/authentication.service';
import { catchError, EMPTY, Observable } from 'rxjs';
import { ProfileResponse } from '@app/core/api';

export const authenticationInitializer = (authenticationService: AuthenticationService) => (): Observable<ProfileResponse> => {
    return authenticationService.fetchAndSetProfile().pipe(catchError(() => EMPTY));
};
